<template>
  <v-card class="update-chart rounded-0" height="auto" elevation="1" style="background: #FAFAFA;">
    <p
      class="grey--text text--darken-1"
      style="position: absolute; left: 50%; -webkit-transform: translate(-50%, 0); top: 45%;"
      v-if="!showTools"
    >คุณยังไม่ได้เพิ่มข้อมูลโครงสร้างบริษัท</p>
    <v-container fluid style="position: absolute;">
        <v-layout column class="fab-container">
          <v-row>
            <v-card
              v-show="showTools"
              outlined
              width="92"
              height="28"
              style="border: 1px solid #C7C7C7'; position: absolute; top: 5px; right: 100px; z-index: 8;"
            ></v-card>
            <v-btn
              id="zoomIn"
              class=""
              :style="`position: absolute; top: 5px; right: 100px; z-index: 8;`"
              icon
              tile
              small
              top
              right
              floating
              fixed
              color="#999999"
              v-show="showTools"
              :dark="!percent==175"
              :disabled="percent==175"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              class=""
              :style="`position: absolute; top: 5px; right: 115px; z-index: 8;`"
              tile
              small
              top
              right
              floating
              fixed
              text
              disabled
              color="#999999"
              v-show="showTools"
            >
              {{ percent }}%
            </v-btn>
            <v-btn
              id="zoomOut"
              class=""
              :style="`position: absolute; top: 5px; right: 165px; z-index: 8;`"
              icon
              tile
              small
              top
              right
              floating
              fixed
              color="#999999"
              v-show="showTools"
              :dark="!percent==25"
              :disabled="percent==25"
            >
              <v-icon dark>
                mdi-minus
              </v-icon>
            </v-btn>
          </v-row>
          <v-card
            class="full-screen-btn"
            outlined
            width="92"
            height="28"
            v-show="showTools"
            @click="showFullScreenChart()"
            style="border: 1px solid #C7C7C7'; position: absolute; top: 5px; right: 5px; z-index: 8;"
          >
          <v-icon>mdi-fullscreen</v-icon>
          <span class="text-no-wrap grey--text text--darken-1 pr-2 ma-0 pa-0 mt-0" style="font-size: 11px;">ดูแบบเต็มจอ</span>
          </v-card>
      </v-layout>
      </v-container>
    <div class="main-container" :style="`min-height: 300px; height: ${isExpand? '45vh':'70vh'};`">
      <div id="chart-container" style=""></div>
    </div>
    <!-- <pre>{{ JSON.stringify(dataChart, null, '\t') }}</pre> -->
  </v-card>
</template>
<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/es6-promise/4.1.1/es6-promise.auto.min.js"></script>
<script type="text/javascript" src="js/jquery.min.js"></script>
<script>
import $ from 'jquery'
import { EventBus } from '@/EventBus'
import FullLoading from '../../_template/FullLoading.vue'
import { hostUrl, fetchViewOrgchart, generateBase64Image, getPreViewOrgchart } from '@/API/API'

const axios = require('axios')
const html2canvas = require('html2canvas')
const FileSaver = require('file-saver')
const wrap = require('word-wrap')

export default {
  props: {
    companyUID: String,
    offsetx: Number,
    offsety: Number,
    type: String,
    isShow: Boolean,
    dataChart: Object,
    isExpand: Boolean
  },
  components: {
    FullLoading
  },
  name: 'dialog-show-chart',
  data () {
    return {
      dialogShowChart: this.isShow,
      scrollPosition: 0,
      offset: 128,
      offsetTop: 0,
      dialog: false,
      showBtn: false,
      zoomval: 1,
      img64Array: [],
      zoomCount: 0,
      canExport: true,
      loading: false,
      loadingOrgchart: false,
      orgchartData: [],
      noData: false,
      loading: false,
      percent: 100,
      colorSet: {
        'สายงาน': '#3D5D85',
        'ฝ่ายงาน': '#5CC2EF',
        'ส่วนงาน': '#6FB540',
        'หน่วยงาน': '#F2BE47;',
        'กลุ่มงาน': '#F37959',
      },
      oc: null,
      orgchart: null
    }
  },
  watch: {
    dataChart: {
      deep: true,
      immediate: true,
      async handler (newVal, oldVal) {
        if (JSON.stringify(newVal) !== '{}') {
          this.loading = true
          // this.percent = 100
          this.oc = null
          await this.createChart(this.dataChart)
          this.loading = false
        }
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.updateScroll)
    EventBus.$on('openDialogShowChart', this.showPreview)
    EventBus.$on('rerenderOrgnChart', this.rerenderOrgnChart)
  },
  beforeDestroy () {
    EventBus.$off('openDialogShowChart')
  },
  computed: {
    showTools () {
      return JSON.stringify(this.dataChart) !== '{}'
    }
  },
  created () {
    // this.getChartData()
        // await self.createChart(result)
    // this.showBtn = false
    // let resource = await this.getChartData()
    // if (resource!==undefined) {
    //   // console.log(resource)
    //   this.createChart(resource)
    //   this.showBtn = true
    // } else {
    //   this.showBtn = false
    // }
  },
  methods: {
    async rerenderOrgnChart (value) {
      this.loading = true
      // this.percent = 100
      this.dataChart = value
      console.log('dataChart', this.dataChart)
      await this.createChart(this.dataChart)
      this.loading = false
    },
    async showPreview (value) {
      this.dialogShowChart = true
      await this.getChartData(value)
    },
    closeShowPreview () {
      // EventBus.$emit('closeDialogShowChart')
      this.dialogShowChart = false
    },
    updateScroll () {
      this.scrollPosition = window.scrollY
    },
    // pressZoomIn () {
    //   console.log('pressZoomIn')
    //   this.zoomval+=0.5
    //   this.oc.setChartScale(this.orgchart, this.zoomval)
    // },
    // pressZoomOut () {
    //   console.log('pressZoomIn')
    //   if (this.zoomval >= 0.5) {
    //     this.zoomval-=0.5
    //     this.oc.setChartScale(this.orgchart, this.zoomval)
    //   }
    // },
    async getChartData (dataForPreview) {
      var oc1 = $('#chart-container').empty()
      let result = undefined
      let self = this
      self.loading = true
      self.orgchartData = []
      try {
        const res = await getPreViewOrgchart(dataForPreview, self.$store.state.token)
        if (res.success) {
          result = res.result
          self.orgchartData = result
          await this.modifyKeys(result)
          self.showBtn = true
        } else {
          result = undefined
          self.showBtn = false
          self.noData = true
        }
      } catch (error) {
        result = undefined
        console.log(error)
      } finally {
        await this.createChart(this.orgchartData)
        self.loading = false
      }
    },
    async getBase64Profile (filePath) {
      let result = [{'base64':''}]
      let self = this
      let obj = {
        "listPart": [
          { "img": filePath }
        ]
      }
      self.loadingOrgchart = true

      try {
        const res = await generateBase64Image(self.$store.state.token, obj)
        if (res.success) {
          result = res.result[0].base64
        } else result = ''
      } catch (error) {
        // console.log(error)
        result = ''
      } finally {
        self.loadingOrgchart = false
      }
      // console.log(result)
      return result
    },
    async modifyKeys(obj){
      for (var key in obj) {
        if (obj[key]!==null) {
          if (key == 'img' && obj['img']!==null) {
            let img64 = await this.getBase64Profile(obj['img'])
            obj['img64'] = 'data:image/jpeg;base64,' + img64.toString()
          }
          if (key == 'name' && obj['name']!==null) {
            obj['name'] = wrap(obj['name'].trim(), {width: 32, newline: '<br>'})
          }
          if (key == 'title' && obj['title']!==null) {
            obj['title'] = wrap(obj['title'].trim(), {width: 32, newline: '<br>'})
          }
          if(typeof obj[key] == 'object'){
            await this.modifyKeys(obj[key])
          }
        }
      }
    },
    nodeTemplate (datasource) {
      {
        if (datasource.img64 === 'data:image/jpeg;base64,') {
          datasource.img64 = '/img/icons/noname.jpg'
        }
        let cssProfileImage = `
        width: 32px;
        height: 32px;
        max-width: 32px !important;
        object-fit: cover;
        border-radius: 50%;
        border : solid;
        border-color: #D3D3D3;
        border-width: thin;
        `
        let cssNode = `
        text-align: center;
        justify-content: center;
        align-items: center;
        padding: 6px 6px 8px;
        width: 200px;
        background: #FFFFFF;
        border: 1px solid ${datasource.nodePreView? this.colorSet[datasource.type]:'#C7C7C7'};
        box-sizing: border-box;
        border-radius: 4px;
        `
        let imagUI = datasource.img==undefined? ``:`<img src="${datasource.img64}" style="${cssProfileImage}"/>`

        let partTitle = `
          <p style="
            margin-top: 2.5px;
            margin-bottom: 2.5px;
            font-family: Sarabun;
            font-style: normal;
            font-weight: bold;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #333333;
          ">${datasource.type=='company'? 'บริษัท':''||''} ${datasource.title||''}</p>
        `

        // var leaderData = datasource.leaderId ? self.itemLeaders.find(el => el._id === datasource.leaderId) : null
        // if (datasource.leaderId) console.log(datasource.leaderId, datasource.searchLeader)
        // else console.log('no leader')
        let partName = `
          <p style="
            margin-top: 5px;
            margin-bottom: 2.5px;
            font-family: Sarabun;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #333333;
          ">${datasource.leaderId? datasource.name.replace('(รก.)', '')||'':''}${datasource.leaderTemp? '(รก.)':''}</p>
        `
        let partPostion = `
          <p style="
            margin-top: 5px;
            margin-bottom: 2.5px;
            font-family: Sarabun;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #757575;
          ">${datasource.leaderId? datasource.position||'':''}</p>
        `

        let lockIcon = `
          <button id="lockicon" class="lockicon" style="position: absolute; right: 12px; top: 5px; cursor: default;">
            <i class="fas fa-lock fa-xs" aria-hidden="true"></i>
          </button>`

        return `
        <div style="
        ${cssNode}
        ">
          <div class="custom-user">
            ${imagUI}
            ${datasource.title? partTitle:''}
            ${datasource.lockEditOrg? lockIcon:''}
            ${datasource.leaderId? '<hr style="margin-top: 4px;">':''}
            ${datasource.leaderId? partName:''}
            ${datasource.leaderId? partPostion:''}
          </div>
        </div>
        `
        // word-wrap: break-word;
      }
    },
    async createChart (data) {
      console.log('createChart')
      var oc1 = $('#chart-container').empty()
      var oc2 = $('.orgchart').empty()
      $('#zoomIn').unbind('click')
      $('#zoomOut').unbind('click')
      var self = this
      // self.percent = 100
      self.oc = null
      self.oc = $('#chart-container').orgchart({
        chartClass: 'chart-container',
        data : data,
        nodeTitle: 'type',
        nodeContent: 'title',
        nodeId: 'id',
        // parentNodeSymbol: 'pid',
        // verticalLevel: 8,
        // visibleLevel: 6,
        // 'direction': 'b2t',
        // 'direction': 'l2r',
        // 'depth': 1,
        // 'verticalDepth': 3,
        pan: false,
        zoom: false,
        // zoominLimit: 3,
        // zoomoutLimit: 1,
        draggable: true,
        dropCriteria: function($draggedNode, $dragZone, $dropZone) {
          // console.log($draggedNode)
          // console.log($draggedNode[0].dataset.parent.toString(), $dropZone[0].id)
          // EventBus.$emit('moveStucture', { from:extraParams.draggedNode[0].id, to:extraParams.dropZone[0].id})
          // $draggedNode[0].draggable = false
          if($draggedNode[0].dataset.parent.toString() === $dropZone[0].id.toString() || ($draggedNode.data('nodeData').lockEditOrg === true)) {
            return false;
          } else {
            return true;
          }
        },
        // parentNodeSymbol: 'fa-users',
        // 'toggleSiblingsResp': true,
        // toggleSiblingsResp: false,
        nodeTemplate: this.nodeTemplate,
        exportButton: false,
        exportFilename: 'orgchart',
        exportFileextension: 'png',
        // 'createNode': function($node, data) {
        //   $node.on('click', function(event) {
        //     if (!$(event.target).is('.edge, .toggleBtn')) {
        //       var $this = $(this);
        //       var $chart = $this.closest('.orgchart');
        //       var newX = window.parseInt(($chart.outerWidth(true)/2) - ($this.offset().left - $chart.offset().left) - ($this.outerWidth(true)/2));
        //       var newY = window.parseInt(($chart.outerHeight(true)/2) - ($this.offset().top - $chart.offset().top) - ($this.outerHeight(true)/2));
        //       $chart.css('transform', 'matrix(1, 0, 0, 1, ' + newX + ', ' + newY + ')');
        //     }
        //   });
        // },
        'initCompleted': function(){
          setTimeout( function(){
            // center the chart to container
            var $container = $('#chart-container');
            var $chart = $('.orgchart');
            $chart.addClass('noncollapsable'); // deactivate
            $chart.css('transform', `scale(${self.zoomval}, ${self.zoomval})`)
            // $chart.css('transform', "scale(1,1)");
            // click event
            $('#chart-container').find('.node').on('click', function () {
              var focusData = $(this).data('nodeData')
              EventBus.$emit('changeFocusIndex', focusData)
            })
            // unclick event
            $('#chart-container').on('click', '.orgchart', function(event) {
              if (!$(event.target).closest('.node').length) {
                $('#selected-node').val('')
                EventBus.$emit('changeFocusIndex', null)
              }
            })
          }  , 0 );
        },
      });
      self.orgchart = $('.orgchart');
      // zoom buttons
      $('#zoomIn').on('click', function () {
        if (self.zoomCount <= 2) {
          self.percent+=25
          self.zoomval+= 0.1235;
          self.zoomCount++
          self.oc.$chart.css('transform', `scale(${self.zoomval}, ${self.zoomval})`)
        }
      });
      $('#zoomOut').on('click', function () {
        if (self.zoomCount >= -2) {
          self.percent-=25
          self.zoomval-=0.1235;
          self.zoomCount--
          if (self.zoomCount.toFixed(1) <= 1.2 ) {
            self.oc.$chart.css('transform', `scale(${self.zoomval}, ${self.zoomval})`)
          }
        }
      });
      // drag&drop event
      self.oc.$chart.on('nodedrop.orgchart', function(event, extraParams) {
        EventBus.$emit('moveStucture', { from:extraParams.draggedNode[0].id, to:extraParams.dropZone[0].id})
      });
    },
    async hideNavbar () {
      EventBus.$emit('hideNavbar')
    },
    async resizeBeforeExport () {
      let $container = $('#chart-container');
      let $chart = $('.orgchart');
      let div = $chart.css('transform');
      let zoomval = 0.4 - (0.039*($chart.width()/$container.width()))
      // let offsetTop = this.offsetTop + (($chart[0].scrollHeight - $chart.height())*Math.abs(3))*4
      let offsetTop = $chart.height() > 2000? this.offsetTop + (($chart[0].scrollHeight - $chart.height())*Math.abs(3))*3:this.offsetTop
      // console.log(offsetTop)
      $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)}, ${-offsetTop}) scale(${zoomval}, ${zoomval})`)
      // $chart.css('transform', `matrix(1, 0, 0, 1, ${(-($chart[0].scrollWidth - $container.width())/2)-this.offsetx+this.offset}, ${(-($container[0].scrollHeight - $container.height())/2)-this.offsety}) scale(${zoomval}, ${zoomval})`)
    },
    async showFullScreenChart () {
      await EventBus.$emit('openDialogShowChartFull', JSON.parse(JSON.stringify(this.dataChart)))
    }
  }
}
</script>

<style lang="scss" scoped>

.update-chart ::v-deep {
  #zoomIn {
    // padding: 50px;
    // margin-right: 100px;
    // right: 135px;
  }
  #zoomOut {
    // padding: 50px;
    // margin-right: 100px;
    // right: 90px;
  }

  .full-screen-btn{
    cursor: pointer;
  }

  .full-screen-btn:hover {
    background-color: #FAFAFA;
  }

  #btn-export{
    right: -18px;
    top: -18px;
  }

  .fab-container {
  //   position: fixed;
  //   bottom: 0;
  //   right: 0;
  }

  .main-container {
    // margin-top: -25px;
    // min-height: 300px;
    // height: 45vh;
    // overflow: hidden;
    overflow: auto;
  }

  .chart-custom {
    // position: relative;
    // display: inline-block;
    // width: calc(100%);
    // overflow: scroll;
  }

  .chart-container {
    // padding: -1000px;
    // margin: 0px;
    // position: relative;
    // display: inline-block;
    // height: 600px;
    // height: calc(100% - 240px);
    // width: calc(100%);
    // border: 2px dashed #aaa;
    // border-radius: 5px;
    // overflow: auto;
    // text-align: center;
    // transform: scale(0.8);
    // transform: scale(0.24);
    // transform-origin: 0 0;
    min-width: 100%;
    width: 100%;
    max-width: 100vh;
    min-width: 100%;
    width: 100%;
    max-width: 100vw;
    // overflow: auto;
    text-align: center;
  }

  .custom-name {
    font-size: 12px;
    margin: 5px 0 0;
    font-weight: 100;
  }
  .custom-role {
    font-size: 20px;
    font-weight: 80;
    margin-bottom: 10px;
    // margin-top: 5px;
  }
  .custom-manager {
    font-size: 12px;
    color: #b21e04;
  }

  .border-chart {
    // text-decoration: none;
    // color: #666;
    font-family: arial, verdana, tahoma;
    display: inline-block;
    padding: 10px 10px;
    // transition: all 0.5s;
    // background: #fff;
    min-width: 220px;
    border-radius: 6px;
    // display:flex;
    // align-items:center;
    // justify-content:center;
    // flex-direction:column;
    box-shadow: 0 1px 3px rgba(black, 0.12), 0 1px 2px rgba(black, 0.24);
  }

  .img-border-chart {
    width: 5vw;
    height: 5vw;
    max-width: 5vw !important;
    border-radius: 50%;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0 0 0 5px #aaa;
  }

  .chart-menu {
      border-width: 10px !important;
      border-color: #aeaeae !important;
      border: 1px solid #aeaeae !important
    }
    [data-item] {
      border-width: 0px !important;
      padding: 10px !important;
    }
    [data-tlbr] {
      margin: 20px !important;
    }
    [data-tlbr="layout"] {
        transform: rotate(0deg) translateX(0px) translateY(0px) !important;
    }
    .shadow {
      -webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .25));
      filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .25));
    }
    /* [node-id] rect {
      fill: #CAE3CC;
    } */
    text {
    font-family: 'Sarabun', sans-serif !important;
    /* font-weight: bold; */
    font-size: 28px;
  }

  .org-chart {
    display: flex;
    justify-content: center;
    ul {
      padding-top: 20px;
      position: relative;
      transition: all 0.5s;
      ul::before {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        border-left: 1px solid #ccc;
        /* // width: 0;
        //height: 20px; */
      }
    }
    li {
      float: left;
      text-align: center;
      list-style-type: none;
      position: relative;
      padding: 10px 10px 10px 10px;
      transition: all 0.5s;
    }
  }

  .orgchart ~ .mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .orgchart ~ .mask .spinner {
    position: absolute;
    top: calc(50% - 54px);
    left: calc(50% - 54px);
    color: rgba(255, 255, 255, 0.8);
    font-size: 108px;
  }
  .orgchart .node {
    transition: transform 0.3s, opacity 0.3s;
  }
  .orgchart .slide-down {
    opacity: 0;
    transform: translateY(40px);
  }
  .orgchart.l2r .node.slide-down,
  .orgchart.r2l .node.slide-down {
    transform: translateY(130px);
  }
  .orgchart .slide-up {
    opacity: 0;
    transform: translateY(-40px);
  }
  .orgchart.l2r .node.slide-up,
  .orgchart.r2l .node.slide-up {
    transform: translateY(-130px);
  }
  .orgchart .slide-right {
    opacity: 0;
    transform: translateX(130px);
  }
  .orgchart.l2r .node.slide-right,
  .orgchart.r2l .node.slide-right {
    transform: translateX(40px);
  }
  .orgchart .slide-left {
    opacity: 0;
    transform: translateX(-130px);
  }
  .orgchart.l2r .node.slide-left,
  .orgchart.r2l .node.slide-left {
    transform: translateX(-40px);
  }

  .orgchart .hidden,
  .orgchart ~ .hidden {
    display: none;
  }
  .orgchart.b2t {
    transform: rotate(180deg);
  }
  .orgchart.l2r {
    position: absolute;
    transform: rotate(-90deg) rotateY(180deg);
    transform-origin: left top;
  }
  .orgchart .verticalNodes ul {
    list-style: none;
    margin: 0;
    padding-left: 18px;
    text-align: left;
  }
  .orgchart .verticalNodes ul:first-child {
    margin-top: 2px;
  }
  .orgchart .verticalNodes > td::before {
    content: "";
    border: 1px solid #999999;
  }
  .orgchart .verticalNodes > td > ul > li:first-child::before {
    box-sizing: border-box;
    top: -4px;
    height: 30px;
    width: calc(50% - 2px);
    border-width: 2px 0 0 2px;
  }
  .orgchart .verticalNodes ul > li {
    position: relative;
  }
  .orgchart .verticalNodes ul > li::before,
  .orgchart .verticalNodes ul > li::after {
    box-sizing: border-box;
    content: "";
    position: absolute;
    left: -6px;
    border-color: #999999;
    border-style: solid;
    border-width: 0 0 2px 2px;
  }
  .orgchart .verticalNodes ul > li::before {
    top: -4px;
    height: 30px;
    width: 11px;
  }
  .orgchart .verticalNodes ul > li::after {
    top: 1px;
    height: 100%;
  }
  .orgchart .verticalNodes ul > li:first-child::after {
    box-sizing: border-box;
    top: 24px;
    width: 11px;
    border-width: 2px 0 0 2px;
  }
  .orgchart .verticalNodes ul > li:last-child::after {
    box-sizing: border-box;
    border-width: 2px 0 0;
  }
  .orgchart.r2l {
    position: absolute;
    transform: rotate(90deg);
    transform-origin: left top;
  }
  .orgchart > .spinner {
    font-size: 100px;
    margin-top: 30px;
    color: rgba(68, 157, 68, 0.8);
  }
  .orgchart table {
    border-spacing: 0;
    border-collapse: separate;
  }
  .orgchart > table:first-child {
    margin: 20px auto;
  }
  .orgchart td {
    text-align: center;
    vertical-align: top;
    padding: 0;
  }
  .orgchart .lines:nth-child(3) td {
    box-sizing: border-box;
    height: 20px;
  }
  .orgchart .lines .topLine {
    border-top: 2px solid #999999;
  }
  .orgchart .lines .rightLine {
    border-right: 1px solid #999999;
    float: none;
    border-radius: 0;
  }
  .orgchart .lines .leftLine {
    border-left: 1px solid #999999;
    float: none;
    border-radius: 0;
  }
  .orgchart .lines .downLine {
    background-color: #999999;
    margin: 0 auto;
    height: 20px;
    width: 2px;
    float: none;
  }
  /* node styling */
  .orgchart .node {
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    margin: 0;
    padding: 3px;
    border: 2px dashed transparent;
    text-align: center;
    width: auto !important;
  }
  .orgchart.l2r .node,
  .orgchart.r2l .node {
    width: 50px;
    height: 130px;
  }
  .orgchart .node > .spinner {
    position: absolute;
    top: calc(50% - 15px);
    left: calc(50% - 15px);
    vertical-align: middle;
    font-size: 30px;
    color: rgba(68, 157, 68, 0.8);
  }
  .orgchart .node:hover {
    background-color: rgba(238, 217, 54, 0.5);
    background-color: transparent !important;
    transition: 0.5s;
    cursor: default;
    z-index: 20;
  }
  .orgchart .node.focused {
    box-shadow:0px 0px 0px 10px #3776E9 inset;
  }
  .orgchart .ghost-node {
    position: fixed;
    left: -10000px;
    top: -10000px;
  }
  .orgchart .ghost-node rect {
    fill: #ffffff;
    stroke: #999999;
  }
  .orgchart .node.allowedDrop {
    border-color: rgba(68, 157, 68, 0.9);
  }
  .orgchart .node .title {
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: #999999;
    color: #fff;
    border-radius: 4px 4px 0 0;
  }
  .orgchart.b2t .node .title {
    transform: rotate(-180deg);
    transform-origin: center bottom;
  }
  .orgchart.l2r .node .title {
    transform: rotate(-90deg) translate(-40px, -40px) rotateY(180deg);
    transform-origin: bottom center;
    width: 120px;
  }
  .orgchart.r2l .node .title {
    transform: rotate(-90deg) translate(-40px, -40px);
    transform-origin: bottom center;
    width: 120px;
  }
  .orgchart .node .title .symbol {
    float: left;
    margin-top: 4px;
    margin-left: 2px;
  }
  .orgchart .node .content {
    box-sizing: border-box;
    width: 100%;
    height: 20px;
    font-size: 11px;
    line-height: 18px;
    border: 1px solid #999999;
    border-radius: 0 0 4px 4px;
    text-align: center;
    background-color: #fff;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .orgchart.b2t .node .content {
    transform: rotate(180deg);
    transform-origin: center top;
  }
  .orgchart.l2r .node .content {
    transform: rotate(-90deg) translate(-40px, -40px) rotateY(180deg);
    transform-origin: top center;
    width: 120px;
  }
  .orgchart.r2l .node .content {
    transform: rotate(-90deg) translate(-40px, -40px);
    transform-origin: top center;
    width: 120px;
  }
  .orgchart .node .edge {
    font-size: 15px;
    position: absolute;
    color: rgba(68, 157, 68, 0.5);
    cursor: default;
    transition: 0.2s;
  }
  .orgchart.noncollapsable .node .edge {
    display: none;
  }
  .orgchart .edge:hover {
    color: #449d44;
    cursor: pointer;
  }
  .orgchart .node .verticalEdge {
    width: calc(100% - 10px);
    width: -webkit-calc(100% - 10px);
    width: -moz-calc(100% - 10px);
    left: 5px;
  }
  .orgchart .node .topEdge {
    top: -4px;
  }
  .orgchart .node .bottomEdge {
    bottom: -4px;
  }
  .orgchart .node .horizontalEdge {
    width: 15px;
    height: calc(100% - 10px);
    height: -webkit-calc(100% - 10px);
    height: -moz-calc(100% - 10px);
    top: 5px;
  }
  .orgchart .node .rightEdge {
    right: -4px;
  }
  .orgchart .node .leftEdge {
    left: -4px;
  }
  .orgchart .node .horizontalEdge::before {
    position: absolute;
    top: calc(50% - 7px);
  }
  .orgchart .node .rightEdge::before {
    right: 3px;
  }
  .orgchart .node .leftEdge::before {
    left: 3px;
  }
  .orgchart .node .toggleBtn {
    position: absolute;
    left: 5px;
    bottom: -2px;
    color: rgba(68, 157, 68, 0.6);
  }
  .orgchart .node .toggleBtn:hover {
    color: rgba(68, 157, 68, 0.8);
  }
  .oc-export-btn {
    width: 76px;
    height: 34px;
    padding-top: -20px;
    top: 0px;
  /* //   display: inline-block; */
    position: absolute;
  }

  .orgchart ~ .mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .orgchart ~ .mask .spinner {
    position: absolute;
    top: calc(50% - 54px);
    left: calc(50% - 54px);
    color: rgba(255, 255, 255, 0.8);
    font-size: 108px;
  }
  .orgchart .node {
    transition: transform 0.3s, opacity 0.3s;
  }
  .orgchart .slide-down {
    opacity: 0;
    transform: translateY(40px);
  }
  .orgchart.l2r .node.slide-down,
  .orgchart.r2l .node.slide-down {
    transform: translateY(130px);
  }
  .orgchart .slide-up {
    opacity: 0;
    transform: translateY(-40px);
  }
  .orgchart.l2r .node.slide-up,
  .orgchart.r2l .node.slide-up {
    transform: translateY(-130px);
  }
  .orgchart .slide-right {
    opacity: 0;
    transform: translateX(130px);
  }
  .orgchart.l2r .node.slide-right,
  .orgchart.r2l .node.slide-right {
    transform: translateX(40px);
  }
  .orgchart .slide-left {
    opacity: 0;
    transform: translateX(-130px);
  }
  .orgchart.l2r .node.slide-left,
  .orgchart.r2l .node.slide-left {
    transform: translateX(-40px);
  }
}
</style>
